import React, { useMemo, useState } from 'react';
import { PageNotFound } from '@components/common';
import { useParams } from 'react-router-dom';
import { getDashboardById, updateLastAccessed } from '@src/utils/dashboard/db';
import { useQuery } from '@tanstack/react-query';
import { logger } from '@src/utils/misc/logger';

// this was a temp workaround done during nexa poc to pass entre dashboard state to model
// not currently used
export let currentTempDashbaordJotaiStoreRef = null;

function ClientTempDashboardHoc({ applyCallback, initStore, children }) {
  const [ready, setReady] = useState(false);
  const { id:tempDashboardId = '-1' } = useParams();

  const { data: dashboard, isFetching, isError } = useQuery(
    ['temp-dashboard', tempDashboardId],
    async () => {
      const dashboard = await getDashboardById(tempDashboardId);
      logger.log('loaded config for temp dashboard', dashboard);
      if (dashboard) {
        applyCallback(dashboard, () => {
          updateLastAccessed(tempDashboardId)
          // init complete
          setReady(true);
        });
      }
      return dashboard;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      notifyOnChangeProps: ['isFetching', 'isError', 'data']
    }
  );

  // intialize jotai store with default state
  const store = useMemo(() => dashboard ? initStore({ dashboard: dashboard.config }) : null, [dashboard, initStore]);
  currentTempDashbaordJotaiStoreRef = store;

  // TODO: add retry loader
  if (isFetching) return <div>Loading...</div>;

  if (isError || !dashboard) {
    return <PageNotFound />;
  }

  return ready ? children({ store, title: dashboard.title  }) : <>Loading...</>;
}

export default ClientTempDashboardHoc;
